//--------------------------------------------------------------------//
//******************** AgentSubscriptionsService *********************//
//--------------------------------------------------------------------//
// API communication layer for an agent's event subscriptions.
// The subscription object's field names match the API directly — no
// field-name remapping is needed. Only alias: subscription_id → id
// for consistent track-by in ng-repeat.
import { request } from '../agents.request.js';

function toClientSubscription(sub) {
    return {
        id: sub.subscription_id,
        subscription_name: sub.subscription_name || '',
        app_id: sub.app_id,
        event_type: sub.event_type,
        active_subscription: sub.active_subscription,
        voice_execution: sub.voice_execution,
        field_id: sub.field_id,
        filter: sub.filter || [],
        listen_for_users: sub.listen_for_users || [],
        prompt: sub.prompt || ''
    };
}

angular.module('agentsTableModule')

    .service('AgentSubscriptionsService', [function () {
        this.getSubscriptions = async function (agentId) {
            const result = await request(`/agents/${encodeURIComponent(agentId)}/subscriptions`, {}, 'GET');
            return { subscriptions: (result.subscriptions || []).map(toClientSubscription) };
        };

        this.createSubscription = function (agentId, data) {
            return request(`/agents/${encodeURIComponent(agentId)}/subscriptions`, data);
        };

        this.updateSubscription = function (agentId, subscriptionId, data) {
            return request(`/agents/${encodeURIComponent(agentId)}/subscriptions/${encodeURIComponent(subscriptionId)}/update`, data);
        };

        this.toggleSubscription = function (agentId, subscriptionId, active) {
            return request(
                `/agents/${encodeURIComponent(agentId)}/subscriptions/${encodeURIComponent(subscriptionId)}/toggle`,
                { active_subscription: active }
            );
        };

        this.deleteSubscription = function (agentId, subscriptionId) {
            return request(`/agents/${encodeURIComponent(agentId)}/subscriptions/${encodeURIComponent(subscriptionId)}/delete`);
        };
    }]);
